import React, { createContext, useContext, useState, useEffect, useRef, useCallback, useMemo, } from 'react';
const ActiveSubmenuContext = createContext({
    activeSubmenu: null,
    setActiveSubmenu: () => {
        throw new Error('setActiveSubmenu function not provided by ActiveSubmenuContext Provider.');
    },
    clearRef: { current: null },
    activeSubmenuRef: { current: null },
});
export const useActiveSubmenuContext = () => useContext(ActiveSubmenuContext);
export const useActiveSubmenu = (uid) => {
    const { setActiveSubmenu, clearRef, activeSubmenuRef } = useActiveSubmenuContext();
    useEffect(() => {
        return () => {
            if (clearRef.current) {
                clearTimeout(clearRef.current);
                clearRef.current = null;
            }
        };
    }, [uid, clearRef]);
    const claimActiveSubmenu = useCallback(() => {
        if (clearRef.current) {
            clearTimeout(clearRef.current);
            clearRef.current = null;
        }
        activeSubmenuRef.current = uid;
        setActiveSubmenu(uid);
    }, [setActiveSubmenu, uid, clearRef, activeSubmenuRef]);
    const clearActiveSubmenu = useCallback(() => {
        clearRef.current = setTimeout(() => {
            if (activeSubmenuRef.current === uid) {
                setActiveSubmenu(null);
            }
        }, 500);
    }, [uid, setActiveSubmenu, clearRef, activeSubmenuRef]);
    return {
        activeSubmenu: activeSubmenuRef.current,
        isActiveSubmenu: activeSubmenuRef.current === uid,
        clearActiveSubmenu,
        claimActiveSubmenu,
    };
};
export const ActiveSubmenuContextProvider = ({ children, }) => {
    const [activeSubmenu, setActiveSubmenu] = useState(null);
    const clearRef = useRef(null);
    const activeSubmenuRef = useRef(null);
    useEffect(() => {
        const timer = clearRef.current;
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);
    const contextValue = useMemo(() => ({
        activeSubmenu,
        setActiveSubmenu,
        clearRef,
        activeSubmenuRef,
    }), [activeSubmenu]);
    return (React.createElement(ActiveSubmenuContext.Provider, { value: contextValue }, children));
};
//# sourceMappingURL=ActiveSubmenuProvider.js.map